module.exports = __webpack_public_path__ + "static/media/rightArrow.f1268454.svg";